import './vendor.ts';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Ng2Webstorage } from 'ng2-webstorage';

import { MarketmanagerSharedModule, UserRouteAccessService } from './shared';
import { MarketmanagerHomeModule } from './home/home.module';
import { MarketmanagerAdminModule } from './admin/admin.module';
import { MarketmanagerAccountModule } from './account/account.module';
import { MarketmanagerEntityModule } from './entities/entity.module';

import { LayoutRoutingModule } from './layouts';
import { customHttpProvider } from './blocks/interceptor/http.provider';
import { PaginationConfig } from './blocks/config/uib-pagination.config';

import {
    JhiMainComponent,
    NavbarComponent,
    FooterComponent,
    ProfileService,
    PageRibbonComponent,
    ActiveMenuDirective,
    ErrorComponent
} from './layouts';

@NgModule({
    imports: [
        BrowserModule,
        LayoutRoutingModule,
        Ng2Webstorage.forRoot({ prefix: 'jhi', separator: '-'}),
        MarketmanagerSharedModule,
        MarketmanagerHomeModule,
        MarketmanagerAdminModule,
        MarketmanagerAccountModule,
        MarketmanagerEntityModule
    ],
    declarations: [
        JhiMainComponent,
        NavbarComponent,
        ErrorComponent,
        PageRibbonComponent,
        ActiveMenuDirective,
        FooterComponent
    ],
    providers: [
        ProfileService,
        customHttpProvider(),
        PaginationConfig,
        UserRouteAccessService
    ],
    bootstrap: [ JhiMainComponent ]
})
export class MarketmanagerAppModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/app.module.ts